// @flow
import * as React from 'react';
import Logo from '../../Logo';
import styles from './styles';

type Props = {
  verticalName: string,
  title: React.Node | string,
  subtitle: React.Node | string,
};

export default function RedirectionLoading({ verticalName, title, subtitle }: Props): React.Node {
  return (
    <div className="header-home">
      <Logo type={verticalName} width={132} />
      <h1>{title}</h1>
      <h2>{subtitle}</h2>
      <style jsx>{styles}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/common/Header/HeaderHome/index.js